// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Tag from 'components/Tag';

// local
import styles from './TagList.pcss';

export default class TagList extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    tagClassName: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
  }
  static defaultProps = {
    tags: [],
  }
    
  render() {
    const { className, tagClassName, tags } = this.props;
    
    const classes = classnames(className, styles.tagList);
    const tagClasses = classnames(tagClassName, styles.tag);
    
    return (
      <div className={ classes }>
        {
          tags.map((tag, i) => (
            <Tag className={ tagClasses } key={ i }>{ tag }</Tag>
          ))
        }
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/TagList/index.jsx